

export enum  ActionsTypes{
    SET_IS_LOADING = "SET_IS_LOADING"
}